import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Shield } from 'lucide-react';
import { getMe } from '@/lib/bootRequests';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * AdminCommunityButton — Round 83 (Feb 14, 2026)
 * Sits in the Dashboard's admin-button row and self-hides for non-admins.
 * Routes to /admin/community where the auto-hidden / king-flagged
 * report queue lives.
 */
export default function AdminCommunityButton() {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [pending, setPending] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getMe()
      .then((d) => { if (!cancelled && d?.role === 'admin') setIsAdmin(true); })
      .catch(() => { /* silent */ });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!isAdmin) return undefined;
    let cancelled = false;
    axios
      .get(`${API}/admin/community/reported`, { withCredentials: true })
      .then((r) => {
        if (cancelled) return;
        const n = (r.data?.posts?.length || 0) + (r.data?.comments?.length || 0);
        setPending(n);
      })
      .catch(() => { if (!cancelled) setPending(null); });
    return () => { cancelled = true; };
  }, [isAdmin]);

  if (!isAdmin) return null;

  const badge = pending != null && pending > 0 ? (
    <span className="ml-1 px-1.5 py-0.5 rounded-full bg-rose-500 text-white text-[10px] font-bold tabular-nums" data-testid="admin-community-pending-count">
      {pending}
    </span>
  ) : null;

  return (
    <button
      type="button"
      onClick={() => navigate('/admin/community')}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-rose-50 dark:bg-rose-950/40 text-rose-700 dark:text-rose-300 border border-rose-200 dark:border-rose-800 text-xs font-semibold hover:bg-rose-100 dark:hover:bg-rose-900/40 transition"
      data-testid="admin-community-btn"
      title="Open Community Moderation Queue"
    >
      <Shield className="w-3.5 h-3.5" />
      Community
      {badge}
    </button>
  );
}
